// extracted by mini-css-extract-plugin
export var locationCard = "_hu-0";